import { getAssetUrl } from "@/utils/common";

export const FONT_ASSETS_LIST: any = [
  [
    "Oswald",
    `url(${getAssetUrl("fonts/Oswald.ttf")})`,
  ],
  // [
  //   "Source Han Sans CN",
  //   `url(${getAssetUrl("fonts/思源黑体/SourceHanSansCN-ExtraLight.otf")})`,
  //   { weight: 200 },
  // ],
  // [
  //   "Source Han Sans CN",
  //   `url(${getAssetUrl("fonts/思源黑体/SourceHanSansCN-Light.otf")})`,
  //   { weight: 300 },
  // ],
  // [
  //   "Source Han Sans CN",
  //   `url(${getAssetUrl("fonts/思源黑体/SourceHanSansCN-Regular.otf")})`,
  //   { weight: 400 },
  // ],
  // [
  //   "Source Han Sans CN",
  //   `url(${getAssetUrl("fonts/思源黑体/SourceHanSansCN-Medium.otf")})`,
  //   { weight: 500 },
  // ],
  // [
  //   "Source Han Sans CN",
  //   `url(${getAssetUrl("fonts/思源黑体/SourceHanSansCN-Bold.otf")})`,
  //   { weight: 700 },
  // ],
  // [
  //   "Source Han Sans CN",
  //   `url(${getAssetUrl("fonts/思源黑体/SourceHanSansCN-Heavy.otf")})`,
  //   { weight: 900 },
  // ],

  [
    "Source Han Serif CN",
    `url(${getAssetUrl("fonts/思源宋体/SourceHanSerifCN-Regular.otf")})`,
    { weight: 400 },
  ],
  [
    "Source Han Serif CN",
    `url(${getAssetUrl("fonts/思源宋体/SourceHanSerifCN-Medium.otf")})`,
    { weight: 500 },
  ],
  [
    "Source Han Serif CN",
    `url(${getAssetUrl("fonts/思源宋体/SourceHanSerifCN-SemiBold.otf")})`,
    { weight: 600 },
  ],
  [
    "Source Han Serif CN",
    `url(${getAssetUrl("fonts/思源宋体/SourceHanSerifCN-Bold.otf")})`,
    { weight: 700 },
  ],
  // [
  //   "Source Han Serif CN",
  //   `url(${getAssetUrl("fonts/思源宋体/SourceHanSerifCN-Heavy.otf")})`,
  //   { weight: 900 },
  // ],
];
